import { render, staticRenderFns } from "./CustomerBalance.vue?vue&type=template&id=3d530380&scoped=true"
import script from "./CustomerBalance.vue?vue&type=script&lang=js"
export * from "./CustomerBalance.vue?vue&type=script&lang=js"
import style0 from "./CustomerBalance.vue?vue&type=style&index=0&id=3d530380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d530380",
  null
  
)

export default component.exports